var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('history-item-template',{attrs:{"createTime":_vm.action.createTime,"creatorName":_vm.action.creatorName,"comment":_vm.action.data.comment,"vbAttachments":_vm.action.attachments},on:{"downloadFile":function (ref) {
      var vbAttachment = ref.vbAttachment;

      return _vm.$emit('downloadFile', {vbAttachment: vbAttachment});
}},scopedSlots:_vm._u([{key:"historyHeader",fn:function(){return [_c('p',{class:[
        'action-type flex-row flex__left inline-flex',
        _vm.classColorByActionName(_vm.action.actionName)
      ]},[_c('i',{class:[
          'font-size__small',
          _vm.classIconByActionName(_vm.action.actionName)
        ]}),_vm._v(" "),_c('span',{staticClass:"font-size__small no_wrap"},[_vm._v("\n         "+_vm._s(_vm.action.actionNameLabel)+"\n      ")])]),_vm._v(" "),_vm._v("\n    "+_vm._s(_vm.buildNameReceivers(_vm.action))+"\n    "+_vm._s(_vm.buildWordTemplate(_vm.action))+"\n    "),_c('doc-in-receivers-info',{attrs:{"categoryVBan":'doc-in',"action":_vm.action,"actionName":_vm.action.actionName}})]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a49e47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/doc-in-history-item.vue
// module id = tNPf
// module chunks = 89